import { render, staticRenderFns } from "./SiatPraticheListPage.vue?vue&type=template&id=72a3472a"
import script from "./SiatPraticheListPage.vue?vue&type=script&lang=js"
export * from "./SiatPraticheListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports